import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";


export default function WartungsprotokollSeite4({ form, setForm }) {

  const [showZusatz1, setShowZusatz1] = useState(false);
  const [showZusatz2, setShowZusatz2] = useState(false);

  if (
    !form ||
    !form.pruefungMontage ||
    !form.sichtkontrolle ||
    !form.zusatz1 ||
    !form.zusatz2
  ) return null;

  // --- update helpers ---
  const updatePruefungMontage = (idx, field) => {
    const copy = [...form.pruefungMontage];
    copy[idx] = { ja: false, nein: false, nz: false, [field]: true };
    setForm(prev => ({ ...prev, pruefungMontage: copy }));
  };

  const updateZusatz1 = (idx, field, value) => {
    const copy = [...form.zusatz1];
    copy[idx][field] = value;
    setForm(prev => ({ ...prev, zusatz1: copy }));
  };

  const updateSichtkontrolle = (idx, field) => {
    const copy = [...form.sichtkontrolle];
    copy[idx] = {
      ja: false,
      nein: false,
      nz: false,
      sbm: false,
      [field]: true
    };
    setForm(prev => ({ ...prev, sichtkontrolle: copy }));
  };

  const updateZusatz2 = (idx, field, value) => {
    const copy = [...form.zusatz2];
    copy[idx][field] = value;
    setForm(prev => ({ ...prev, zusatz2: copy }));
  };

  return (
    
    <div className="p-6 text-sm">
      <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
      {/* SECTION 3 */}
      <h2 style={{ fontWeight: "bold" }}>
        3- Überprüfung von Montagestell (Stichprobenartig, verteilt)
      </h2>
      
      <table className="w-full table-fixed border mb-6 text-xs">
          <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "3.1 Das Montagestell ist frei von Beschädigungen",
            "3.2 Das Montagestell ist frei von Roststellen",
            "3.3 Das Montagestell ist richtig montiert",
            "3.4 Die Anzugsmomente der Gestellverschraubungen sind richtig (33-56 Nm)",
            "3.5 Die Modulklemmen sind frei von Beschädigungen",
            "3.6 Die Modulklemmen sind richtig montiert",
            "3.7 Die Anzugsmomente der Modulklemmen sind richtig (10 Nm) — Mindestens 500 Stellen prüfen",
            "3.8 Der Potentialausgleich ist frei von Beschädigungen",
            "3.9 Die Beschriftung der Modulreihen ist in Ordnung",
            "3.10 Der Diebstahlschutz der Module ist vorhanden und frei von Schäden",
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={form.pruefungMontage?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMontage || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, pruefungMontage: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={form.pruefungMontage?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMontage || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, pruefungMontage: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={form.pruefungMontage?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.pruefungMontage || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, pruefungMontage: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

       {/* Button for ZUSATZ-TABELLE #1 */}
          <Box mb={3} mt={4}>
      
              <Button
                onClick={() => setShowZusatz1(!showZusatz1)}
                colorScheme="blue"
                borderRadius="lg"
              >
                {showZusatz1 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
              </Button>
      
         </Box>

    

      {/* ZUSATZ-TABELLE #1 */}
      {showZusatz1 && (
        <>
      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table className="w-full mb-6 text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bemerkungen / Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatz1.map((row, i) => (
            <tr key={i}>
              {/* Zu Punkt */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.zupunkt}
                  onChange={e => updateZusatz1(i, "zupunkt", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* Bemerkung */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.bemerkung}
                  onChange={e => updateZusatz1(i, "bemerkung", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* Standort */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.standort}
                  onChange={e => updateZusatz1(i, "standort", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* Plan */}
              <td style={{ border: "1px solid #ccc", padding: "2px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={e => updateZusatz1(i, "plan", e.target.checked)}
                />
              </td>

              {/* Bildnr */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz1(i, "bildnr", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* Beh */}
              <td style={{ border: "1px solid #ccc", padding: "2px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.beh}
                  onChange={e => updateZusatz1(i, "beh", e.target.checked)}
                />
              </td>

              {/* n.Beh */}
              <td style={{ border: "1px solid #ccc", padding: "2px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.nbeh}
                  onChange={e => updateZusatz1(i, "nbeh", e.target.checked)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
        </>
       )}
  </Box>

    <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>

      {/* SECTION 4 */}
      <h2 style={{ fontWeight: "bold" }}>
        4- Sichtkontrolle Strangleitungen (sichtbar und zugänglich)
      </h2>

      <table className="w-full table-fixed border mb-6 text-xs">
        <thead>
          <tr className="border-b font-semibold text-center">
            <th className="p-2 w-2/3 text-left"></th>
            <th className="p-2 min-w-[90px]">ja</th>
            <th className="p-2 min-w-[90px]">nein</th>
            <th className="p-2 min-w-[90px]">nicht zutreffend</th>
          </tr>
        </thead>
        <tbody>
          {[
            "4.1 Die Strangleitungen sind frei von Beschädigungen",
            "4.2 Die Strangleitungen sind frei von Schmorspuren",
            "4.3 Die Verbindungsstellen sind frei von Beschädigungen (Steckverbindungen usw.)",
            "4.4 Die Kabelverlegung ist ordnungsgemäß",
          ].map((text, idx) => (
            <tr key={idx}>
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "70%" }}>
                {text}
              </td>

              {/* Ja */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={form.sichtkontrolle?.[idx]?.ja || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.sichtkontrolle || [])];
                      list[idx] = { ja: true, nein: false, nz: false };
                      return { ...f, sichtkontrolle: list };
                    })
                  }
                />
              </td>

              {/* Nein */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={form.sichtkontrolle?.[idx]?.nein || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.sichtkontrolle || [])];
                      list[idx] = { ja: false, nein: true, nz: false };
                      return { ...f, sichtkontrolle: list };
                    })
                  }
                />
              </td>

              {/* n.z. */}
              <td style={{ border: "1px solid #ccc", padding: "4px", width: "10%", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={form.sichtkontrolle?.[idx]?.nz || false}
                  onChange={() =>
                    setForm(f => {
                      const list = [...(f.sichtkontrolle || [])];
                      list[idx] = { ja: false, nein: false, nz: true };
                      return { ...f, sichtkontrolle: list };
                    })
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>


          <Box mb={3} mt={4}>
      
              <Button
                onClick={() => setShowZusatz2(!showZusatz2)}
                colorScheme="blue"
                borderRadius="lg"
              >
                {showZusatz2 ? "Zusatz-Tabelle minimieren" : "Zusatz-Tabelle anzeigen"}
              </Button>
      
              </Box>


              {/* ZUSATZ-TABELLE #2 */}

       {showZusatz2 && (
        <>

      
      <h3 className="font-semibold mb-2 mt-4">Zusatz-Tabelle</h3>

      <table
        className="w-full table-fixed mb-6 text-xs"
        style={{ borderCollapse: "collapse" }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Zu Punkt</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bemerkungen / Mängel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Standort Mangel</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Plan</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Bild-Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>Beh.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px" }}>n. Beh.</th>
          </tr>
        </thead>

        <tbody>
          {form.zusatz2.map((row, i) => (
            <tr key={i}>

              {/* zupunkt */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.zupunkt}
                  onChange={e => updateZusatz2(i, "zupunkt", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* bemerkung */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.bemerkung}
                  onChange={e => updateZusatz2(i, "bemerkung", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* standort */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.standort}
                  onChange={e => updateZusatz2(i, "standort", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* plan */}
              <td style={{ border: "1px solid #ccc", padding: "2px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.plan}
                  onChange={e => updateZusatz2(i, "plan", e.target.checked)}
                />
              </td>

              {/* bildnr */}
              <td style={{ border: "1px solid #ccc", padding: "2px" }}>
                <input
                  type="text"
                  value={row.bildnr}
                  onChange={e => updateZusatz2(i, "bildnr", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* beh */}
              <td style={{ border: "1px solid #ccc", padding: "2px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.beh}
                  onChange={e => updateZusatz2(i, "beh", e.target.checked)}
                />
              </td>

              {/* nbeh */}
              <td style={{ border: "1px solid #ccc", padding: "2px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.nbeh}
                  onChange={e => updateZusatz2(i, "nbeh", e.target.checked)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
        </>
       )}
         </Box>

    </div>

  );
}